import { Modal } from "antd";
import { FC, useEffect } from "react";
import { postMessengerReceivedDelivery } from "tm-shared/api";

import { PrimaryText, SecondaryText } from "@/shared/ui/Typography";
import { ModalPayloads, ModalType } from "@/types/modals";

import { StyledConfirmButton } from "./Styled";

export interface MessageModalProps {
    payload: ModalPayloads[ModalType.Messages] | null;
    onCloseModal: () => void;
}

const MessageModal: FC<MessageModalProps> = ({ payload, onCloseModal }) => {
    useEffect(() => {
        if (payload?.deliveryId) {
            postMessengerReceivedDelivery({
                deliveryId: payload?.deliveryId,
            });
        }
    }, [payload?.deliveryId]);

    if (!payload) return null;

    const handleCloseMessageModal = () => {
        onCloseModal();
    };

    return (
        <Modal open title="" closable={false} centered footer={[]}>
            <PrimaryText
                style={{ textAlign: "center" }}
                fontSize={20}
                fontWeight="500"
            >
                {payload.subject}
            </PrimaryText>
            <SecondaryText style={{ marginTop: "16px" }}>
                {payload.content}
            </SecondaryText>

            <StyledConfirmButton
                type="primary"
                onClick={handleCloseMessageModal}
            >
                Ок
            </StyledConfirmButton>
        </Modal>
    );
};

export default MessageModal;
